export type Option<IDType extends string = string> = {
  id: IDType;
  label: string;
};

export const handleMultiSelectChange = (
  value: Option[],
  options: Option[],
  defaultValue?: string[],
  allOptionId: string = 'ALL',
): Option[] => {
  if (value.length === 0) {
    return defaultValue
      ? options.filter(opt => defaultValue.includes(opt.id))
      : [];
  }

  if (value.some(val => val.id === allOptionId)) {
    if (value.at(-1).id === allOptionId) {
      return [options[0]];
    } else {
      return value.filter(val => val.id !== allOptionId);
    }
  } else {
    return value;
  }
};
